
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/[categorySku]",
      function () {
        return require("private-next-pages/book/[categorySku]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/[categorySku]"])
      });
    }
  